const stripLeadingSectionNumber = (title) =>
  (title || "").replace(/^\s*\d+(?:\.\d+)*\.?\s*/, "").trim();

export const getCombinedPlanVisibleSections = (data, options = {}) => {
  if (!data) {
    return [];
  }

  const sections = [];

  if (data.LearningAreas?.length > 0) {
    sections.push("learningAreas");
  }

  if (
    (data.DiscussionPrevVasuNotes?.Title || "") !== "" ||
    (data.DiscussionPrevVasuNotes?.SubTitle || "") !== "" ||
    (data.DiscussionPrevVasuNotes?.Text || "") !== "" ||
    (data.DiscussionObjectives?.EvaluationSections &&
      data.DiscussionObjectives.EvaluationSections.length > 0) ||
    (data.DiscussionOtherItems?.EvaluationSections &&
      data.DiscussionOtherItems.EvaluationSections.length > 0)
  ) {
    sections.push("discussion");
  }

  const supportHasActiveTier =
    data.SupportTiers?.GeneralSupport?.StartDate != null ||
    data.SupportTiers?.EnhancedSupport?.StartDate != null ||
    data.SupportTiers?.SpecialSupport?.StartDate != null;

  if (supportHasActiveTier || options.hasLeopsSupportPlan) {
    sections.push("support");
  }

  if (
    data.IsLeopsActive &&
    data.SpringEvaluation &&
    (data.SpringEvaluation.IndependentSection ||
      data.SpringEvaluation.TeacherSummarySection)
  ) {
    sections.push("springEvaluation");
  }

  if (data.DescriptionOfChildRows?.length > 0) {
    sections.push("description");
  }

  return sections;
};

export const getCombinedPlanSectionTitle = (
  data,
  sectionKey,
  rawTitle,
  fallback = "",
  options = {},
) => {
  const baseTitle = stripLeadingSectionNumber(rawTitle || fallback);
  const index = getCombinedPlanVisibleSections(data, options).indexOf(
    sectionKey,
  );

  if (!baseTitle) {
    return "";
  }

  return index >= 0 ? `${index + 1}. ${baseTitle}` : baseTitle;
};
